import { handleActions } from 'redux-actions';
import { Record } from 'immutable';
import {
  INIT,
  SAVE_STARTED,
  SAVED,
  REFRESH_STARTED,
  REFRESHED,
  DISCONNECTED,
  ERROR,
} from 'app/models/autosave/actions';

const Autosave = Record({
  connected:        true,
  saveTimestamp:    undefined,
  refreshTimestamp: undefined,
  error:            null,
  saving:           false,
  refreshing:       false,
});

const ok = (state) => state.set('connected', true).set('error', null);

export const autosaveReducer = handleActions({
  [INIT]:            (state, action) => Autosave(),
  [SAVE_STARTED]:    (state, action) =>
                       state.set('saving', true),
  [SAVED]:           (state, action) =>
                       ok(state).set('saveTimestamp', Date.now())
                                .set('saving', false),
  [REFRESH_STARTED]: (state, action) =>
                       state.set('refreshing', true),
  [REFRESHED]:       (state, action) =>
                       ok(state).set('refreshTimestamp', Date.now())
                                .set('refreshing', false),
  [DISCONNECTED]:    (state, action) =>
                       state.set('connected', false)
                            .set('refreshing', false)
                            .set('saving', false),
  [ERROR]:           (state, { payload: error }) =>
                       state.set('error', error)
                            .set('refreshing', false)
                            .set('saving', false),
}, Autosave());
